module.exports = __webpack_public_path__ + "img/CROWN GREEN.f478a52.svg";